module.exports = __webpack_public_path__ + "static/media/class4.eaec41f2.jpg";